<template>
  <section class="sec sec-03 mt-5 mb-5 sec-padding">
    <div class="sec-03-hex">
      <div class="model1">
        <span  class="blue-light"></span><span  class="blue-light"></span><span  class="blue-light"></span>
      </div>
       <div class="model2">
          <span  class="blue-light"></span><span  class="blue-light"></span>
       </div>
       <div class="model3">
          <span  class="blue-light"></span><span  class="blue-light"></span><span  class="blue-light"></span><span  class="blue-light"></span>
       </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="sec-title mt-5">
          <h1 class="has-u-line wow fadeInUp" data-wow-duration="1s" data-wow-delay="1s" v-html="title"></h1>
          <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="1.2s" v-html="titleSub"></p>
        </div>
      </div>
      <div class="row justify-content-center">
          <div class="col-lg-10 rm-con-con">
              <div class="roadmap-container wow fadeInUp" data-wow-duration="1.4s" >
                   <span class="c-lights">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.011 125.343">
  <g id="Group_334" data-name="Group 334" transform="translate(-186.198 -690.274)">
    <g id="bl1" data-name="Group 2938" opacity="1">
      <g id="Group_2936" data-name="Group 2936">
        <path id="Path_2135-2" data-name="Path 2135-2" d="M201.451,750.142A8.192,8.192,0,0,0,198,746.693a3.587,3.587,0,0,0-3.394-.185c-1.929,1.116-2.637,4.248-1.729,7.649a24.644,24.644,0,0,0,1.138,3.182l.029.071a7.709,7.709,0,0,1,.572,2.28,8.482,8.482,0,0,0,.493,2.351,4.01,4.01,0,0,0,.519.965,1.989,1.989,0,0,0,.656.578c.37.2,1.49.7,2.184,1.006l.482.214a1.008,1.008,0,0,0,1.382-.347,1.027,1.027,0,0,0,.089-.19,4.016,4.016,0,0,0,.377-1.313,5.559,5.559,0,0,1,1.024-2.893,6.23,6.23,0,0,0,.616-1.157A10.388,10.388,0,0,0,201.451,750.142Zm-4.821,11.29a.331.331,0,0,1-.049-.026v-.024a13.833,13.833,0,0,1-.241-1.457,11.374,11.374,0,0,0-.789-3.078l-.218-.556c-.278-.675-.528-1.363-.746-2.057-.683-2.2-.346-4.317.829-5.2a2.185,2.185,0,0,1,2.313-.1c.077.034.16.069.238.113a6.669,6.669,0,0,1,3.2,4.995,5.486,5.486,0,0,1-.587,3.714l-.043.075c-.083.153-.173.3-.27.445a6.438,6.438,0,0,0-1.18,3.425,3.116,3.116,0,0,1-.161.693l-.011.034a.251.251,0,0,1-.048-.016c-.161-.076-.322-.148-.482-.221l-.309-.135-.342-.149-.585-.262c-.161-.071-.322-.143-.483-.206Z" fill="#3699c4"/>
        <path id="Path_2136-2" data-name="Path 2136-2" d="M199.714,766.282a1.377,1.377,0,0,1,.16.659c-.011.457-.3.691-.643.526l-.04-.021L198.177,767l-1.329-.584-.556-.242a1.209,1.209,0,0,1-.68-1.043v-.063a.671.671,0,0,1,.161-.511.46.46,0,0,1,.517-.043q1.448.631,2.893,1.269A1.13,1.13,0,0,1,199.714,766.282Z" fill="#3699c4"/>
        <path id="Path_2137-2" data-name="Path 2137-2" d="M199.714,768.285a1.367,1.367,0,0,1,.16.66c-.009.455-.3.693-.643.529l-.043-.022-1.9-.831-1-.44a1.216,1.216,0,0,1-.68-1.05v-.059a.673.673,0,0,1,.161-.511.456.456,0,0,1,.517-.041q1.447.631,2.893,1.272A1.121,1.121,0,0,1,199.714,768.285Z" fill="#3699c4"/>
        <path id="Path_2138-2" data-name="Path 2138-2" d="M199.143,770.553c0,.454-.275.7-.615.554l-.036-.016c-.172-.071-.342-.151-.514-.227l-.686-.3-.3-.13a1.242,1.242,0,0,1-.643-1.074v-.045c0-.453.272-.7.611-.556l.043.021q.747.321,1.493.654a1.224,1.224,0,0,1,.643,1.061Z" fill="#3699c4"/>
        <path id="Path_2139-2" data-name="Path 2139-2" d="M190.156,751.465c-.492-.211-.987-.426-1.477-.643s-.935-.41-1.406-.622a1.732,1.732,0,0,1-.789-.771,2.259,2.259,0,0,1-.286-1.092c.011-.761.482-1.163,1.056-.9l.032.014,2.864,1.256a1.756,1.756,0,0,1,.792.779,2.263,2.263,0,0,1,.284,1.085c0,.757-.472,1.162-1.041.905Z" fill="#3699c4"/>
        <path id="Path_2140-2" data-name="Path 2140-2" d="M193.136,743.35a2.523,2.523,0,0,1,.353,1.211,1.105,1.105,0,0,1-.283.8.617.617,0,0,1-.707.121,1.822,1.822,0,0,1-.813-.82c-.228-.394-.463-.8-.691-1.2l-1.332-2.339a1.8,1.8,0,0,1-.089-2l.02-.018a.624.624,0,0,1,.718-.116,1.9,1.9,0,0,1,.8.8Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2" data-name="Path 2141-2" d="M192.814,758.1a1.684,1.684,0,0,1-.009,1.938l-.018.015c-.677.622-1.352,1.24-2.035,1.846a.679.679,0,0,1-.774.106,1.633,1.633,0,0,1-.723-.726,1.68,1.68,0,0,1,.008-1.929l.04-.032c.231-.217.467-.432.7-.643l.607-.546q.35-.325.7-.643a.687.687,0,0,1,.778-.109A1.666,1.666,0,0,1,192.814,758.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2" data-name="Path 2142-2" d="M202.425,749.1h0a1.647,1.647,0,0,1,.048-1.928l.023-.018,2.023-1.78a.723.723,0,0,1,.789-.111,1.669,1.669,0,0,1,.731.757,1.644,1.644,0,0,1-.046,1.928l-.024.019c-.221.2-.449.4-.672.593l-1.355,1.19a.7.7,0,0,1-.783.107A1.685,1.685,0,0,1,202.425,749.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2" data-name="Path 2143-2" d="M198.783,740.167v3.8a1.276,1.276,0,0,1-.321.942.643.643,0,0,1-.707.067,2.087,2.087,0,0,1-1.032-1.817v-3.89a1.233,1.233,0,0,1,.321-.946.643.643,0,0,1,.731-.052,2.14,2.14,0,0,1,1.006,1.869Z" fill="#3699c4"/>
        <path id="Path_2144-2" data-name="Path 2144-2" d="M206.409,766.819a1.767,1.767,0,0,1,.072,1.975l-.029.029a.629.629,0,0,1-.718.094,1.794,1.794,0,0,1-.783-.794q-1.019-1.8-2.031-3.629a1.748,1.748,0,0,1-.04-1.969l.012-.013a.636.636,0,0,1,.711-.1,1.829,1.829,0,0,1,.791.8c.231.411.466.829.7,1.252Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2" data-name="Path 2145-2" d="M209.065,758.555v.01a1.126,1.126,0,0,1-.29.834.7.7,0,0,1-.79.079c-.467-.2-.935-.405-1.4-.609-.495-.217-.985-.433-1.48-.654a2.067,2.067,0,0,1-1.064-1.794v-.034a1.1,1.1,0,0,1,.286-.835.692.692,0,0,1,.794-.082l2.858,1.252a2.072,2.072,0,0,1,1.089,1.8Z" fill="#3699c4"/>
      </g>
      <g id="Group_2937" data-name="Group 2937">
        <path id="Path_2135-2-2" data-name="Path 2135-2-2" d="M201.451,750.142A8.192,8.192,0,0,0,198,746.693a3.587,3.587,0,0,0-3.394-.185c-1.929,1.116-2.637,4.248-1.729,7.649a24.644,24.644,0,0,0,1.138,3.182l.029.071a7.709,7.709,0,0,1,.572,2.28,8.482,8.482,0,0,0,.493,2.351,4.01,4.01,0,0,0,.519.965,1.989,1.989,0,0,0,.656.578c.37.2,1.49.7,2.184,1.006l.482.214a1.008,1.008,0,0,0,1.382-.347,1.027,1.027,0,0,0,.089-.19,4.016,4.016,0,0,0,.377-1.313,5.559,5.559,0,0,1,1.024-2.893,6.23,6.23,0,0,0,.616-1.157A10.388,10.388,0,0,0,201.451,750.142Zm-4.821,11.29a.331.331,0,0,1-.049-.026v-.024a13.833,13.833,0,0,1-.241-1.457,11.374,11.374,0,0,0-.789-3.078l-.218-.556c-.278-.675-.528-1.363-.746-2.057-.683-2.2-.346-4.317.829-5.2a2.185,2.185,0,0,1,2.313-.1c.077.034.16.069.238.113a6.669,6.669,0,0,1,3.2,4.995,5.486,5.486,0,0,1-.587,3.714l-.043.075c-.083.153-.173.3-.27.445a6.438,6.438,0,0,0-1.18,3.425,3.116,3.116,0,0,1-.161.693l-.011.034a.251.251,0,0,1-.048-.016c-.161-.076-.322-.148-.482-.221l-.309-.135-.342-.149-.585-.262c-.161-.071-.322-.143-.483-.206Z" fill="#3699c4"/>
        <path id="Path_2136-2-2" data-name="Path 2136-2-2" d="M199.714,766.282a1.377,1.377,0,0,1,.16.659c-.011.457-.3.691-.643.526l-.04-.021L198.177,767l-1.329-.584-.556-.242a1.209,1.209,0,0,1-.68-1.043v-.063a.671.671,0,0,1,.161-.511.46.46,0,0,1,.517-.043q1.448.631,2.893,1.269A1.13,1.13,0,0,1,199.714,766.282Z" fill="#3699c4"/>
        <path id="Path_2137-2-2" data-name="Path 2137-2-2" d="M199.714,768.285a1.367,1.367,0,0,1,.16.66c-.009.455-.3.693-.643.529l-.043-.022-1.9-.831-1-.44a1.216,1.216,0,0,1-.68-1.05v-.059a.673.673,0,0,1,.161-.511.456.456,0,0,1,.517-.041q1.447.631,2.893,1.272A1.121,1.121,0,0,1,199.714,768.285Z" fill="#3699c4"/>
        <path id="Path_2138-2-2" data-name="Path 2138-2-2" d="M199.143,770.553c0,.454-.275.7-.615.554l-.036-.016c-.172-.071-.342-.151-.514-.227l-.686-.3-.3-.13a1.242,1.242,0,0,1-.643-1.074v-.045c0-.453.272-.7.611-.556l.043.021q.747.321,1.493.654a1.224,1.224,0,0,1,.643,1.061Z" fill="#3699c4"/>
        <path id="Path_2139-2-2" data-name="Path 2139-2-2" d="M190.156,751.465c-.492-.211-.987-.426-1.477-.643s-.935-.41-1.406-.622a1.732,1.732,0,0,1-.789-.771,2.259,2.259,0,0,1-.286-1.092c.011-.761.482-1.163,1.056-.9l.032.014,2.864,1.256a1.756,1.756,0,0,1,.792.779,2.263,2.263,0,0,1,.284,1.085c0,.757-.472,1.162-1.041.905Z" fill="#3699c4"/>
        <path id="Path_2140-2-2" data-name="Path 2140-2-2" d="M193.136,743.35a2.523,2.523,0,0,1,.353,1.211,1.105,1.105,0,0,1-.283.8.617.617,0,0,1-.707.121,1.822,1.822,0,0,1-.813-.82c-.228-.394-.463-.8-.691-1.2l-1.332-2.339a1.8,1.8,0,0,1-.089-2l.02-.018a.624.624,0,0,1,.718-.116,1.9,1.9,0,0,1,.8.8Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2-2" data-name="Path 2141-2-2" d="M192.814,758.1a1.684,1.684,0,0,1-.009,1.938l-.018.015c-.677.622-1.352,1.24-2.035,1.846a.679.679,0,0,1-.774.106,1.633,1.633,0,0,1-.723-.726,1.68,1.68,0,0,1,.008-1.929l.04-.032c.231-.217.467-.432.7-.643l.607-.546q.35-.325.7-.643a.687.687,0,0,1,.778-.109A1.666,1.666,0,0,1,192.814,758.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2-2" data-name="Path 2142-2-2" d="M202.425,749.1h0a1.647,1.647,0,0,1,.048-1.928l.023-.018,2.023-1.78a.723.723,0,0,1,.789-.111,1.669,1.669,0,0,1,.731.757,1.644,1.644,0,0,1-.046,1.928l-.024.019c-.221.2-.449.4-.672.593l-1.355,1.19a.7.7,0,0,1-.783.107A1.685,1.685,0,0,1,202.425,749.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2-2" data-name="Path 2143-2-2" d="M198.783,740.167v3.8a1.276,1.276,0,0,1-.321.942.643.643,0,0,1-.707.067,2.087,2.087,0,0,1-1.032-1.817v-3.89a1.233,1.233,0,0,1,.321-.946.643.643,0,0,1,.731-.052,2.14,2.14,0,0,1,1.006,1.869Z" fill="#3699c4"/>
        <path id="Path_2144-2-2" data-name="Path 2144-2-2" d="M206.409,766.819a1.767,1.767,0,0,1,.072,1.975l-.029.029a.629.629,0,0,1-.718.094,1.794,1.794,0,0,1-.783-.794q-1.019-1.8-2.031-3.629a1.748,1.748,0,0,1-.04-1.969l.012-.013a.636.636,0,0,1,.711-.1,1.829,1.829,0,0,1,.791.8c.231.411.466.829.7,1.252Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2-2" data-name="Path 2145-2-2" d="M209.065,758.555v.01a1.126,1.126,0,0,1-.29.834.7.7,0,0,1-.79.079c-.467-.2-.935-.405-1.4-.609-.495-.217-.985-.433-1.48-.654a2.067,2.067,0,0,1-1.064-1.794v-.034a1.1,1.1,0,0,1,.286-.835.692.692,0,0,1,.794-.082l2.858,1.252a2.072,2.072,0,0,1,1.089,1.8Z" fill="#3699c4"/>
      </g>
    </g>
    <g id="bl2" data-name="Group 2939" opacity="1">
      <g id="Group_2936-2" data-name="Group 2936-2">
        <path id="Path_2135-2-3" data-name="Path 2135-2-3" d="M368.592,750.142a8.192,8.192,0,0,0-3.454-3.449,3.587,3.587,0,0,0-3.394-.185c-1.929,1.116-2.637,4.248-1.729,7.649a24.639,24.639,0,0,0,1.138,3.182l.029.071a7.709,7.709,0,0,1,.572,2.28,8.482,8.482,0,0,0,.493,2.351,4.01,4.01,0,0,0,.519.965,1.989,1.989,0,0,0,.656.578c.37.2,1.49.7,2.184,1.006l.482.214a1.008,1.008,0,0,0,1.382-.347,1.026,1.026,0,0,0,.089-.19,4.016,4.016,0,0,0,.377-1.313,5.55,5.55,0,0,1,1.024-2.893,6.23,6.23,0,0,0,.616-1.157A10.388,10.388,0,0,0,368.592,750.142Zm-4.821,11.29a.332.332,0,0,1-.049-.026v-.024a13.837,13.837,0,0,1-.241-1.457,11.373,11.373,0,0,0-.789-3.078l-.218-.556c-.278-.675-.528-1.363-.746-2.057-.683-2.2-.346-4.317.829-5.2a2.185,2.185,0,0,1,2.313-.1c.077.034.16.069.238.113a6.665,6.665,0,0,1,3.2,4.995,5.48,5.48,0,0,1-.586,3.714l-.043.075a5.028,5.028,0,0,1-.271.445,6.445,6.445,0,0,0-1.179,3.425,3.115,3.115,0,0,1-.161.693l-.011.034a.251.251,0,0,1-.048-.016c-.161-.076-.322-.148-.482-.221l-.309-.135-.342-.149-.585-.262c-.161-.071-.322-.143-.483-.206Z" fill="#3699c4"/>
        <path id="Path_2136-2-3" data-name="Path 2136-2-3" d="M366.855,766.282a1.378,1.378,0,0,1,.16.659c-.011.457-.3.691-.643.526l-.04-.021L365.318,767l-1.329-.584-.556-.242a1.209,1.209,0,0,1-.68-1.043v-.063a.671.671,0,0,1,.161-.511.46.46,0,0,1,.517-.043q1.447.631,2.893,1.269A1.13,1.13,0,0,1,366.855,766.282Z" fill="#3699c4"/>
        <path id="Path_2137-2-3" data-name="Path 2137-2-3" d="M366.855,768.285a1.367,1.367,0,0,1,.16.66c-.009.455-.3.693-.643.529l-.043-.022-1.9-.831-1-.44a1.216,1.216,0,0,1-.68-1.05v-.059a.673.673,0,0,1,.161-.511.456.456,0,0,1,.517-.041q1.447.631,2.893,1.272A1.122,1.122,0,0,1,366.855,768.285Z" fill="#3699c4"/>
        <path id="Path_2138-2-3" data-name="Path 2138-2-3" d="M366.284,770.553c0,.454-.275.7-.615.554l-.036-.016c-.172-.071-.342-.151-.514-.227l-.686-.3-.3-.13a1.242,1.242,0,0,1-.643-1.074v-.045c0-.453.272-.7.611-.556l.043.021q.747.321,1.493.654a1.225,1.225,0,0,1,.643,1.061Z" fill="#3699c4"/>
        <path id="Path_2139-2-3" data-name="Path 2139-2-3" d="M357.3,751.465c-.492-.211-.987-.426-1.477-.643s-.935-.41-1.406-.622a1.732,1.732,0,0,1-.789-.771,2.258,2.258,0,0,1-.286-1.092c.011-.761.482-1.163,1.056-.9l.032.014,2.864,1.256a1.756,1.756,0,0,1,.792.779,2.263,2.263,0,0,1,.284,1.085c0,.757-.472,1.162-1.041.905Z" fill="#3699c4"/>
        <path id="Path_2140-2-3" data-name="Path 2140-2-3" d="M360.277,743.35a2.523,2.523,0,0,1,.353,1.211,1.11,1.11,0,0,1-.283.8.617.617,0,0,1-.707.121,1.822,1.822,0,0,1-.813-.82c-.228-.394-.463-.8-.691-1.2l-1.332-2.339a1.8,1.8,0,0,1-.089-2l.02-.018a.624.624,0,0,1,.718-.116,1.9,1.9,0,0,1,.8.8Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2-3" data-name="Path 2141-2-3" d="M359.955,758.1a1.686,1.686,0,0,1-.009,1.938l-.018.015c-.677.622-1.352,1.24-2.035,1.846a.679.679,0,0,1-.774.106,1.64,1.64,0,0,1-.724-.726,1.682,1.682,0,0,1,.009-1.929l.04-.032c.231-.217.467-.432.7-.643l.607-.546q.35-.325.7-.643a.687.687,0,0,1,.778-.109A1.666,1.666,0,0,1,359.955,758.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2-3" data-name="Path 2142-2-3" d="M369.566,749.1h0a1.647,1.647,0,0,1,.048-1.928l.023-.018,2.023-1.78a.723.723,0,0,1,.789-.111,1.669,1.669,0,0,1,.731.757,1.644,1.644,0,0,1-.046,1.928l-.024.019c-.221.2-.449.4-.672.593l-1.355,1.19a.7.7,0,0,1-.783.107A1.685,1.685,0,0,1,369.566,749.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2-3" data-name="Path 2143-2-3" d="M365.924,740.167v3.8a1.276,1.276,0,0,1-.321.942.645.645,0,0,1-.708.067,2.088,2.088,0,0,1-1.031-1.817v-3.89a1.233,1.233,0,0,1,.321-.946.643.643,0,0,1,.731-.052,2.14,2.14,0,0,1,1.006,1.869Z" fill="#3699c4"/>
        <path id="Path_2144-2-3" data-name="Path 2144-2-3" d="M373.55,766.819a1.767,1.767,0,0,1,.072,1.975l-.029.029a.629.629,0,0,1-.718.094,1.794,1.794,0,0,1-.783-.794q-1.019-1.8-2.031-3.629a1.748,1.748,0,0,1-.04-1.969l.012-.013a.636.636,0,0,1,.711-.1,1.822,1.822,0,0,1,.79.8c.232.411.467.829.7,1.252Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2-3" data-name="Path 2145-2-3" d="M376.206,758.555v.01a1.126,1.126,0,0,1-.29.834.7.7,0,0,1-.79.079c-.467-.2-.935-.405-1.4-.609-.495-.217-.985-.433-1.48-.654a2.067,2.067,0,0,1-1.064-1.794v-.034a1.093,1.093,0,0,1,.286-.835.692.692,0,0,1,.794-.082l2.858,1.252a2.072,2.072,0,0,1,1.089,1.8Z" fill="#3699c4"/>
      </g>
      <g id="Group_2937-2" data-name="Group 2937-2">
        <path id="Path_2135-2-4" data-name="Path 2135-2-4" d="M368.592,750.142a8.192,8.192,0,0,0-3.454-3.449,3.587,3.587,0,0,0-3.394-.185c-1.929,1.116-2.637,4.248-1.729,7.649a24.639,24.639,0,0,0,1.138,3.182l.029.071a7.709,7.709,0,0,1,.572,2.28,8.482,8.482,0,0,0,.493,2.351,4.01,4.01,0,0,0,.519.965,1.989,1.989,0,0,0,.656.578c.37.2,1.49.7,2.184,1.006l.482.214a1.008,1.008,0,0,0,1.382-.347,1.026,1.026,0,0,0,.089-.19,4.016,4.016,0,0,0,.377-1.313,5.55,5.55,0,0,1,1.024-2.893,6.23,6.23,0,0,0,.616-1.157A10.388,10.388,0,0,0,368.592,750.142Zm-4.821,11.29a.332.332,0,0,1-.049-.026v-.024a13.837,13.837,0,0,1-.241-1.457,11.373,11.373,0,0,0-.789-3.078l-.218-.556c-.278-.675-.528-1.363-.746-2.057-.683-2.2-.346-4.317.829-5.2a2.185,2.185,0,0,1,2.313-.1c.077.034.16.069.238.113a6.665,6.665,0,0,1,3.2,4.995,5.48,5.48,0,0,1-.586,3.714l-.043.075a5.028,5.028,0,0,1-.271.445,6.445,6.445,0,0,0-1.179,3.425,3.115,3.115,0,0,1-.161.693l-.011.034a.251.251,0,0,1-.048-.016c-.161-.076-.322-.148-.482-.221l-.309-.135-.342-.149-.585-.262c-.161-.071-.322-.143-.483-.206Z" fill="#3699c4"/>
        <path id="Path_2136-2-4" data-name="Path 2136-2-4" d="M366.855,766.282a1.378,1.378,0,0,1,.16.659c-.011.457-.3.691-.643.526l-.04-.021L365.318,767l-1.329-.584-.556-.242a1.209,1.209,0,0,1-.68-1.043v-.063a.671.671,0,0,1,.161-.511.46.46,0,0,1,.517-.043q1.447.631,2.893,1.269A1.13,1.13,0,0,1,366.855,766.282Z" fill="#3699c4"/>
        <path id="Path_2137-2-4" data-name="Path 2137-2-4" d="M366.855,768.285a1.367,1.367,0,0,1,.16.66c-.009.455-.3.693-.643.529l-.043-.022-1.9-.831-1-.44a1.216,1.216,0,0,1-.68-1.05v-.059a.673.673,0,0,1,.161-.511.456.456,0,0,1,.517-.041q1.447.631,2.893,1.272A1.122,1.122,0,0,1,366.855,768.285Z" fill="#3699c4"/>
        <path id="Path_2138-2-4" data-name="Path 2138-2-4" d="M366.284,770.553c0,.454-.275.7-.615.554l-.036-.016c-.172-.071-.342-.151-.514-.227l-.686-.3-.3-.13a1.242,1.242,0,0,1-.643-1.074v-.045c0-.453.272-.7.611-.556l.043.021q.747.321,1.493.654a1.225,1.225,0,0,1,.643,1.061Z" fill="#3699c4"/>
        <path id="Path_2139-2-4" data-name="Path 2139-2-4" d="M357.3,751.465c-.492-.211-.987-.426-1.477-.643s-.935-.41-1.406-.622a1.732,1.732,0,0,1-.789-.771,2.258,2.258,0,0,1-.286-1.092c.011-.761.482-1.163,1.056-.9l.032.014,2.864,1.256a1.756,1.756,0,0,1,.792.779,2.263,2.263,0,0,1,.284,1.085c0,.757-.472,1.162-1.041.905Z" fill="#3699c4"/>
        <path id="Path_2140-2-4" data-name="Path 2140-2-4" d="M360.277,743.35a2.523,2.523,0,0,1,.353,1.211,1.11,1.11,0,0,1-.283.8.617.617,0,0,1-.707.121,1.822,1.822,0,0,1-.813-.82c-.228-.394-.463-.8-.691-1.2l-1.332-2.339a1.8,1.8,0,0,1-.089-2l.02-.018a.624.624,0,0,1,.718-.116,1.9,1.9,0,0,1,.8.8Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2-4" data-name="Path 2141-2-4" d="M359.955,758.1a1.686,1.686,0,0,1-.009,1.938l-.018.015c-.677.622-1.352,1.24-2.035,1.846a.679.679,0,0,1-.774.106,1.64,1.64,0,0,1-.724-.726,1.682,1.682,0,0,1,.009-1.929l.04-.032c.231-.217.467-.432.7-.643l.607-.546q.35-.325.7-.643a.687.687,0,0,1,.778-.109A1.666,1.666,0,0,1,359.955,758.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2-4" data-name="Path 2142-2-4" d="M369.566,749.1h0a1.647,1.647,0,0,1,.048-1.928l.023-.018,2.023-1.78a.723.723,0,0,1,.789-.111,1.669,1.669,0,0,1,.731.757,1.644,1.644,0,0,1-.046,1.928l-.024.019c-.221.2-.449.4-.672.593l-1.355,1.19a.7.7,0,0,1-.783.107A1.685,1.685,0,0,1,369.566,749.1Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2-4" data-name="Path 2143-2-4" d="M365.924,740.167v3.8a1.276,1.276,0,0,1-.321.942.645.645,0,0,1-.708.067,2.088,2.088,0,0,1-1.031-1.817v-3.89a1.233,1.233,0,0,1,.321-.946.643.643,0,0,1,.731-.052,2.14,2.14,0,0,1,1.006,1.869Z" fill="#3699c4"/>
        <path id="Path_2144-2-4" data-name="Path 2144-2-4" d="M373.55,766.819a1.767,1.767,0,0,1,.072,1.975l-.029.029a.629.629,0,0,1-.718.094,1.794,1.794,0,0,1-.783-.794q-1.019-1.8-2.031-3.629a1.748,1.748,0,0,1-.04-1.969l.012-.013a.636.636,0,0,1,.711-.1,1.822,1.822,0,0,1,.79.8c.232.411.467.829.7,1.252Z" fill="#3699c4" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2-4" data-name="Path 2145-2-4" d="M376.206,758.555v.01a1.126,1.126,0,0,1-.29.834.7.7,0,0,1-.79.079c-.467-.2-.935-.405-1.4-.609-.495-.217-.985-.433-1.48-.654a2.067,2.067,0,0,1-1.064-1.794v-.034a1.093,1.093,0,0,1,.286-.835.692.692,0,0,1,.794-.082l2.858,1.252a2.072,2.072,0,0,1,1.089,1.8Z" fill="#3699c4"/>
      </g>
    </g>
    <g id="bl3" data-name="Group 2934" opacity="1">
      <g id="Group_2923" data-name="Group 2923">
        <path id="Path_2135-2-5" data-name="Path 2135-2-5" d="M282.436,700.762a7.2,7.2,0,0,0-3.03-3.025,3.148,3.148,0,0,0-2.978-.161c-1.691.979-2.313,3.727-1.517,6.71a21.693,21.693,0,0,0,1,2.79l.026.063a6.778,6.778,0,0,1,.5,2,7.421,7.421,0,0,0,.434,2.062,3.489,3.489,0,0,0,.455.846,1.764,1.764,0,0,0,.575.508c.322.172,1.307.615,1.916.882l.426.188a.885.885,0,0,0,1.212-.313.912.912,0,0,0,.074-.158,3.537,3.537,0,0,0,.331-1.152,4.862,4.862,0,0,1,.9-2.536,5.37,5.37,0,0,0,.538-1.016A9.107,9.107,0,0,0,282.436,700.762Zm-4.226,9.9a.15.15,0,0,1-.041-.023v-.021a11.389,11.389,0,0,1-.211-1.285,9.979,9.979,0,0,0-.693-2.7l-.191-.482q-.366-.889-.654-1.8a4.249,4.249,0,0,1,.727-4.566,1.914,1.914,0,0,1,2.028-.087c.069.031.136.06.209.1a5.851,5.851,0,0,1,2.807,4.381,4.791,4.791,0,0,1-.516,3.257l-.037.068a4.432,4.432,0,0,1-.237.389,5.65,5.65,0,0,0-1.034,3.005,2.75,2.75,0,0,1-.143.607l-.009.031a.189.189,0,0,1-.042-.014c-.142-.066-.285-.131-.428-.193l-.271-.119-.3-.132-.514-.228c-.143-.063-.286-.126-.428-.182Z" fill="#7ed6fc"/>
        <path id="Path_2136-2-5" data-name="Path 2136-2-5" d="M280.91,714.924a1.179,1.179,0,0,1,.146.578c-.009.4-.263.606-.565.461l-.036-.019-.888-.391-1.166-.511-.482-.213a1.055,1.055,0,0,1-.6-.913v-.056a.586.586,0,0,1,.148-.449.4.4,0,0,1,.453-.037q1.27.553,2.541,1.114A.96.96,0,0,1,280.91,714.924Z" fill="#7ed6fc"/>
        <path id="Path_2137-2-5" data-name="Path 2137-2-5" d="M280.91,716.68a1.19,1.19,0,0,1,.146.58c-.009.4-.26.608-.562.463l-.039-.019-1.662-.728-.88-.387a1.063,1.063,0,0,1-.6-.921v-.052a.6.6,0,0,1,.145-.448.406.406,0,0,1,.454-.036q1.273.555,2.543,1.116A.988.988,0,0,1,280.91,716.68Z" fill="#7ed6fc"/>
        <path id="Path_2138-2-5" data-name="Path 2138-2-5" d="M280.411,718.668c0,.4-.242.616-.54.482l-.031-.014c-.151-.061-.3-.132-.452-.2l-.6-.263-.263-.116a1.088,1.088,0,0,1-.568-.942v-.038c0-.4.238-.618.536-.483l.038.018q.656.283,1.31.575a1.071,1.071,0,0,1,.57.931Z" fill="#7ed6fc"/>
        <path id="Path_2139-2-5" data-name="Path 2139-2-5" d="M272.528,701.928c-.431-.184-.865-.374-1.3-.564s-.819-.358-1.232-.545a1.512,1.512,0,0,1-.693-.676,1.975,1.975,0,0,1-.251-.964c.008-.667.423-1.019.926-.788l.029.015,2.51,1.1a1.534,1.534,0,0,1,.7.683,1.985,1.985,0,0,1,.249.952c0,.664-.415,1.019-.913.792Z" fill="#7ed6fc"/>
        <path id="Path_2140-2-5" data-name="Path 2140-2-5" d="M275.144,694.809a2.2,2.2,0,0,1,.31,1.061.965.965,0,0,1-.247.7.543.543,0,0,1-.621.106,1.584,1.584,0,0,1-.713-.718c-.2-.346-.407-.7-.606-1.058l-1.168-2.051a1.581,1.581,0,0,1-.078-1.753l.015-.016a.549.549,0,0,1,.631-.1,1.684,1.684,0,0,1,.7.708Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2-5" data-name="Path 2141-2-5" d="M274.853,707.746a1.476,1.476,0,0,1-.008,1.7l-.016.013c-.591.546-1.185,1.089-1.784,1.62a.6.6,0,0,1-.68.095,1.452,1.452,0,0,1-.633-.643,1.474,1.474,0,0,1,0-1.694l.035-.029c.2-.19.41-.379.618-.567l.533-.483c.2-.189.41-.379.617-.562a.6.6,0,0,1,.682-.1A1.452,1.452,0,0,1,274.853,707.746Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2-5" data-name="Path 2142-2-5" d="M283.289,699.857h0a1.448,1.448,0,0,1,.043-1.694l.02-.016,1.767-1.562a.644.644,0,0,1,.693-.1,1.471,1.471,0,0,1,.643.664,1.446,1.446,0,0,1-.04,1.687l-.021.017c-.194.178-.394.348-.59.52l-1.189,1.043a.6.6,0,0,1-.685.095A1.47,1.47,0,0,1,283.289,699.857Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2-5" data-name="Path 2143-2-5" d="M280.094,692.017v3.335a1.115,1.115,0,0,1-.281.824.56.56,0,0,1-.621.062,1.833,1.833,0,0,1-.9-1.6v-3.411a1.082,1.082,0,0,1,.282-.831.557.557,0,0,1,.643-.045,1.877,1.877,0,0,1,.884,1.64Z" fill="#7ed6fc"/>
        <path id="Path_2144-2-5" data-name="Path 2144-2-5" d="M286.784,715.394a1.558,1.558,0,0,1,.063,1.735l-.024.024a.557.557,0,0,1-.632.082,1.57,1.57,0,0,1-.686-.7q-.893-1.582-1.781-3.184a1.532,1.532,0,0,1-.037-1.726l.013-.011a.553.553,0,0,1,.624-.087,1.593,1.593,0,0,1,.693.7c.2.361.409.728.612,1.1Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2-5" data-name="Path 2145-2-5" d="M289.115,708.146v.008a.982.982,0,0,1-.256.732.613.613,0,0,1-.693.07c-.409-.175-.819-.355-1.229-.535s-.865-.379-1.3-.574a1.812,1.812,0,0,1-.933-1.573v-.029a.952.952,0,0,1,.252-.733.6.6,0,0,1,.694-.074l2.509,1.1a1.818,1.818,0,0,1,.955,1.575Z" fill="#7ed6fc"/>
      </g>
      <g id="Group_2933" data-name="Group 2933">
        <path id="Path_2135-2-6" data-name="Path 2135-2-6" d="M282.436,700.762a7.2,7.2,0,0,0-3.03-3.025,3.148,3.148,0,0,0-2.978-.161c-1.691.979-2.313,3.727-1.517,6.71a21.693,21.693,0,0,0,1,2.79l.026.063a6.778,6.778,0,0,1,.5,2,7.421,7.421,0,0,0,.434,2.062,3.489,3.489,0,0,0,.455.846,1.764,1.764,0,0,0,.575.508c.322.172,1.307.615,1.916.882l.426.188a.885.885,0,0,0,1.212-.313.912.912,0,0,0,.074-.158,3.537,3.537,0,0,0,.331-1.152,4.862,4.862,0,0,1,.9-2.536,5.37,5.37,0,0,0,.538-1.016A9.107,9.107,0,0,0,282.436,700.762Zm-4.226,9.9a.15.15,0,0,1-.041-.023v-.021a11.389,11.389,0,0,1-.211-1.285,9.979,9.979,0,0,0-.693-2.7l-.191-.482q-.366-.889-.654-1.8a4.249,4.249,0,0,1,.727-4.566,1.914,1.914,0,0,1,2.028-.087c.069.031.136.06.209.1a5.851,5.851,0,0,1,2.807,4.381,4.791,4.791,0,0,1-.516,3.257l-.037.068a4.432,4.432,0,0,1-.237.389,5.65,5.65,0,0,0-1.034,3.005,2.75,2.75,0,0,1-.143.607l-.009.031a.189.189,0,0,1-.042-.014c-.142-.066-.285-.131-.428-.193l-.271-.119-.3-.132-.514-.228c-.143-.063-.286-.126-.428-.182Z" fill="#75fffa"/>
        <path id="Path_2136-2-6" data-name="Path 2136-2-6" d="M280.91,714.924a1.179,1.179,0,0,1,.146.578c-.009.4-.263.606-.565.461l-.036-.019-.888-.391-1.166-.511-.482-.213a1.055,1.055,0,0,1-.6-.913v-.056a.586.586,0,0,1,.148-.449.4.4,0,0,1,.453-.037q1.27.553,2.541,1.114A.96.96,0,0,1,280.91,714.924Z" fill="#75fffa"/>
        <path id="Path_2137-2-6" data-name="Path 2137-2-6" d="M280.91,716.68a1.19,1.19,0,0,1,.146.58c-.009.4-.26.608-.562.463l-.039-.019-1.662-.728-.88-.387a1.063,1.063,0,0,1-.6-.921v-.052a.6.6,0,0,1,.145-.448.406.406,0,0,1,.454-.036q1.273.555,2.543,1.116A.988.988,0,0,1,280.91,716.68Z" fill="#75fffa"/>
        <path id="Path_2138-2-6" data-name="Path 2138-2-6" d="M280.411,718.668c0,.4-.242.616-.54.482l-.031-.014c-.151-.061-.3-.132-.452-.2l-.6-.263-.263-.116a1.088,1.088,0,0,1-.568-.942v-.038c0-.4.238-.618.536-.483l.038.018q.656.283,1.31.575a1.071,1.071,0,0,1,.57.931Z" fill="#75fffa"/>
        <path id="Path_2139-2-6" data-name="Path 2139-2-6" d="M272.528,701.928c-.431-.184-.865-.374-1.3-.564s-.819-.358-1.232-.545a1.512,1.512,0,0,1-.693-.676,1.975,1.975,0,0,1-.251-.964c.008-.667.423-1.019.926-.788l.029.015,2.51,1.1a1.534,1.534,0,0,1,.7.683,1.985,1.985,0,0,1,.249.952c0,.664-.415,1.019-.913.792Z" fill="#75fffa"/>
        <path id="Path_2140-2-6" data-name="Path 2140-2-6" d="M275.144,694.809a2.2,2.2,0,0,1,.31,1.061.965.965,0,0,1-.247.7.543.543,0,0,1-.621.106,1.584,1.584,0,0,1-.713-.718c-.2-.346-.407-.7-.606-1.058l-1.168-2.051a1.581,1.581,0,0,1-.078-1.753l.015-.016a.549.549,0,0,1,.631-.1,1.684,1.684,0,0,1,.7.708Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2-6" data-name="Path 2141-2-6" d="M274.853,707.746a1.476,1.476,0,0,1-.008,1.7l-.016.013c-.591.546-1.185,1.089-1.784,1.62a.6.6,0,0,1-.68.095,1.452,1.452,0,0,1-.633-.643,1.474,1.474,0,0,1,0-1.694l.035-.029c.2-.19.41-.379.618-.567l.533-.483c.2-.189.41-.379.617-.562a.6.6,0,0,1,.682-.1A1.452,1.452,0,0,1,274.853,707.746Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2-6" data-name="Path 2142-2-6" d="M283.289,699.857h0a1.448,1.448,0,0,1,.043-1.694l.02-.016,1.767-1.562a.644.644,0,0,1,.693-.1,1.471,1.471,0,0,1,.643.664,1.446,1.446,0,0,1-.04,1.687l-.021.017c-.194.178-.394.348-.59.52l-1.189,1.043a.6.6,0,0,1-.685.095A1.47,1.47,0,0,1,283.289,699.857Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2-6" data-name="Path 2143-2-6" d="M280.094,692.017v3.335a1.115,1.115,0,0,1-.281.824.56.56,0,0,1-.621.062,1.833,1.833,0,0,1-.9-1.6v-3.411a1.082,1.082,0,0,1,.282-.831.557.557,0,0,1,.643-.045,1.877,1.877,0,0,1,.884,1.64Z" fill="#75fffa"/>
        <path id="Path_2144-2-6" data-name="Path 2144-2-6" d="M286.784,715.394a1.558,1.558,0,0,1,.063,1.735l-.024.024a.557.557,0,0,1-.632.082,1.57,1.57,0,0,1-.686-.7q-.893-1.582-1.781-3.184a1.532,1.532,0,0,1-.037-1.726l.013-.011a.553.553,0,0,1,.624-.087,1.593,1.593,0,0,1,.693.7c.2.361.409.728.612,1.1Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2-6" data-name="Path 2145-2-6" d="M289.115,708.146v.008a.982.982,0,0,1-.256.732.613.613,0,0,1-.693.07c-.409-.175-.819-.355-1.229-.535s-.865-.379-1.3-.574a1.812,1.812,0,0,1-.933-1.573v-.029a.952.952,0,0,1,.252-.733.6.6,0,0,1,.694-.074l2.509,1.1a1.818,1.818,0,0,1,.955,1.575Z" fill="#75fffa"/>
      </g>
    </g>
    <g id="bl4" data-name="Group 2935" opacity="1">
      <g id="Group_2923-2" data-name="Group 2923-2">
        <path id="Path_2135-2-7" data-name="Path 2135-2-7" d="M282.436,797.189a7.205,7.205,0,0,0-3.03-3.025,3.148,3.148,0,0,0-2.978-.16c-1.691.978-2.313,3.727-1.517,6.709a21.693,21.693,0,0,0,1,2.79l.026.063a6.777,6.777,0,0,1,.5,2,7.429,7.429,0,0,0,.434,2.062,3.482,3.482,0,0,0,.455.845,1.752,1.752,0,0,0,.575.508c.322.172,1.307.616,1.916.882l.426.188a.884.884,0,0,0,1.212-.313.937.937,0,0,0,.074-.157,3.549,3.549,0,0,0,.331-1.153,4.862,4.862,0,0,1,.9-2.536,5.36,5.36,0,0,0,.538-1.015A9.109,9.109,0,0,0,282.436,797.189Zm-4.226,9.9a.148.148,0,0,1-.041-.022v-.021a11.446,11.446,0,0,1-.211-1.286,9.988,9.988,0,0,0-.693-2.7l-.191-.482q-.366-.888-.654-1.8a4.249,4.249,0,0,1,.727-4.566,1.912,1.912,0,0,1,2.028-.087c.069.031.136.059.209.1a5.851,5.851,0,0,1,2.807,4.381,4.793,4.793,0,0,1-.516,3.258l-.037.067a4.162,4.162,0,0,1-.237.389,5.652,5.652,0,0,0-1.034,3.005,2.758,2.758,0,0,1-.143.608l-.009.03a.186.186,0,0,1-.042-.014c-.142-.066-.285-.13-.428-.193l-.271-.119-.3-.132-.514-.228c-.143-.062-.286-.125-.428-.181Z" fill="#7ed6fc"/>
        <path id="Path_2136-2-7" data-name="Path 2136-2-7" d="M280.91,811.351a1.18,1.18,0,0,1,.146.579c-.009.4-.263.6-.565.461l-.036-.019-.888-.391-1.166-.511-.482-.214a1.054,1.054,0,0,1-.6-.913v-.056a.584.584,0,0,1,.148-.448.4.4,0,0,1,.453-.037q1.27.552,2.541,1.113A.964.964,0,0,1,280.91,811.351Z" fill="#7ed6fc"/>
        <path id="Path_2137-2-7" data-name="Path 2137-2-7" d="M280.91,813.108a1.184,1.184,0,0,1,.146.58c-.009.4-.26.607-.562.463l-.039-.02-1.662-.728-.88-.387a1.063,1.063,0,0,1-.6-.921v-.051a.6.6,0,0,1,.145-.449.407.407,0,0,1,.454-.035q1.273.555,2.543,1.115A.985.985,0,0,1,280.91,813.108Z" fill="#7ed6fc"/>
        <path id="Path_2138-2-7" data-name="Path 2138-2-7" d="M280.411,815.1c0,.4-.242.615-.54.482l-.031-.015c-.151-.061-.3-.132-.452-.2l-.6-.264-.263-.116a1.087,1.087,0,0,1-.568-.941v-.039c0-.4.238-.617.536-.482l.038.018q.656.282,1.31.575a1.07,1.07,0,0,1,.57.93Z" fill="#7ed6fc"/>
        <path id="Path_2139-2-7" data-name="Path 2139-2-7" d="M272.528,798.356c-.431-.185-.865-.375-1.3-.564s-.819-.359-1.232-.545a1.519,1.519,0,0,1-.693-.677,1.969,1.969,0,0,1-.251-.964c.008-.667.423-1.019.926-.787l.029.014,2.51,1.1a1.524,1.524,0,0,1,.7.683,1.979,1.979,0,0,1,.249.951c0,.664-.415,1.019-.913.793Z" fill="#7ed6fc"/>
        <path id="Path_2140-2-7" data-name="Path 2140-2-7" d="M275.144,791.236a2.209,2.209,0,0,1,.31,1.061.963.963,0,0,1-.247.7.539.539,0,0,1-.621.106,1.584,1.584,0,0,1-.713-.718c-.2-.345-.407-.7-.606-1.057l-1.168-2.051a1.583,1.583,0,0,1-.078-1.754l.015-.016a.552.552,0,0,1,.631-.1,1.681,1.681,0,0,1,.7.709Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2-7" data-name="Path 2141-2-7" d="M274.853,804.174a1.475,1.475,0,0,1-.008,1.7l-.016.013c-.591.547-1.185,1.09-1.784,1.62a.6.6,0,0,1-.68.095,1.447,1.447,0,0,1-.633-.643,1.474,1.474,0,0,1,0-1.694l.035-.029c.2-.189.41-.379.618-.567l.533-.482c.2-.19.41-.379.617-.563a.6.6,0,0,1,.682-.1A1.454,1.454,0,0,1,274.853,804.174Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2-7" data-name="Path 2142-2-7" d="M283.289,796.284h0a1.448,1.448,0,0,1,.043-1.694l.02-.016,1.767-1.562a.642.642,0,0,1,.693-.1,1.468,1.468,0,0,1,.643.663,1.448,1.448,0,0,1-.04,1.688l-.021.016c-.194.178-.394.349-.59.521l-1.189,1.043a.608.608,0,0,1-.685.1A1.478,1.478,0,0,1,283.289,796.284Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2-7" data-name="Path 2143-2-7" d="M280.094,788.445v3.335a1.116,1.116,0,0,1-.281.824.562.562,0,0,1-.621.061,1.831,1.831,0,0,1-.9-1.6v-3.41a1.079,1.079,0,0,1,.282-.831.557.557,0,0,1,.643-.045,1.875,1.875,0,0,1,.884,1.639Z" fill="#7ed6fc"/>
        <path id="Path_2144-2-7" data-name="Path 2144-2-7" d="M286.784,811.822a1.557,1.557,0,0,1,.063,1.734l-.024.024a.555.555,0,0,1-.632.082,1.57,1.57,0,0,1-.686-.7q-.893-1.581-1.781-3.183a1.534,1.534,0,0,1-.037-1.727l.013-.011a.555.555,0,0,1,.624-.087,1.6,1.6,0,0,1,.693.7c.2.362.409.728.612,1.1Z" fill="#7ed6fc" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2-7" data-name="Path 2145-2-7" d="M289.115,804.574v.008a.979.979,0,0,1-.256.731.613.613,0,0,1-.693.071c-.409-.175-.819-.355-1.229-.535s-.865-.38-1.3-.574a1.814,1.814,0,0,1-.933-1.574v-.028a.951.951,0,0,1,.252-.733.6.6,0,0,1,.694-.074l2.509,1.1a1.819,1.819,0,0,1,.955,1.575Z" fill="#7ed6fc"/>
      </g>
      <g id="Group_2933-2" data-name="Group 2933-2">
        <path id="Path_2135-2-8" data-name="Path 2135-2-8" d="M282.436,797.189a7.205,7.205,0,0,0-3.03-3.025,3.148,3.148,0,0,0-2.978-.16c-1.691.978-2.313,3.727-1.517,6.709a21.693,21.693,0,0,0,1,2.79l.026.063a6.777,6.777,0,0,1,.5,2,7.429,7.429,0,0,0,.434,2.062,3.482,3.482,0,0,0,.455.845,1.752,1.752,0,0,0,.575.508c.322.172,1.307.616,1.916.882l.426.188a.884.884,0,0,0,1.212-.313.937.937,0,0,0,.074-.157,3.549,3.549,0,0,0,.331-1.153,4.862,4.862,0,0,1,.9-2.536,5.36,5.36,0,0,0,.538-1.015A9.109,9.109,0,0,0,282.436,797.189Zm-4.226,9.9a.148.148,0,0,1-.041-.022v-.021a11.446,11.446,0,0,1-.211-1.286,9.988,9.988,0,0,0-.693-2.7l-.191-.482q-.366-.888-.654-1.8a4.249,4.249,0,0,1,.727-4.566,1.912,1.912,0,0,1,2.028-.087c.069.031.136.059.209.1a5.851,5.851,0,0,1,2.807,4.381,4.793,4.793,0,0,1-.516,3.258l-.037.067a4.162,4.162,0,0,1-.237.389,5.652,5.652,0,0,0-1.034,3.005,2.758,2.758,0,0,1-.143.608l-.009.03a.186.186,0,0,1-.042-.014c-.142-.066-.285-.13-.428-.193l-.271-.119-.3-.132-.514-.228c-.143-.062-.286-.125-.428-.181Z" fill="#75fffa"/>
        <path id="Path_2136-2-8" data-name="Path 2136-2-8" d="M280.91,811.351a1.18,1.18,0,0,1,.146.579c-.009.4-.263.6-.565.461l-.036-.019-.888-.391-1.166-.511-.482-.214a1.054,1.054,0,0,1-.6-.913v-.056a.584.584,0,0,1,.148-.448.4.4,0,0,1,.453-.037q1.27.552,2.541,1.113A.964.964,0,0,1,280.91,811.351Z" fill="#75fffa"/>
        <path id="Path_2137-2-8" data-name="Path 2137-2-8" d="M280.91,813.108a1.184,1.184,0,0,1,.146.58c-.009.4-.26.607-.562.463l-.039-.02-1.662-.728-.88-.387a1.063,1.063,0,0,1-.6-.921v-.051a.6.6,0,0,1,.145-.449.407.407,0,0,1,.454-.035q1.273.555,2.543,1.115A.985.985,0,0,1,280.91,813.108Z" fill="#75fffa"/>
        <path id="Path_2138-2-8" data-name="Path 2138-2-8" d="M280.411,815.1c0,.4-.242.615-.54.482l-.031-.015c-.151-.061-.3-.132-.452-.2l-.6-.264-.263-.116a1.087,1.087,0,0,1-.568-.941v-.039c0-.4.238-.617.536-.482l.038.018q.656.282,1.31.575a1.07,1.07,0,0,1,.57.93Z" fill="#75fffa"/>
        <path id="Path_2139-2-8" data-name="Path 2139-2-8" d="M272.528,798.356c-.431-.185-.865-.375-1.3-.564s-.819-.359-1.232-.545a1.519,1.519,0,0,1-.693-.677,1.969,1.969,0,0,1-.251-.964c.008-.667.423-1.019.926-.787l.029.014,2.51,1.1a1.524,1.524,0,0,1,.7.683,1.979,1.979,0,0,1,.249.951c0,.664-.415,1.019-.913.793Z" fill="#75fffa"/>
        <path id="Path_2140-2-8" data-name="Path 2140-2-8" d="M275.144,791.236a2.209,2.209,0,0,1,.31,1.061.963.963,0,0,1-.247.7.539.539,0,0,1-.621.106,1.584,1.584,0,0,1-.713-.718c-.2-.345-.407-.7-.606-1.057l-1.168-2.051a1.583,1.583,0,0,1-.078-1.754l.015-.016a.552.552,0,0,1,.631-.1,1.681,1.681,0,0,1,.7.709Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2141-2-8" data-name="Path 2141-2-8" d="M274.853,804.174a1.475,1.475,0,0,1-.008,1.7l-.016.013c-.591.547-1.185,1.09-1.784,1.62a.6.6,0,0,1-.68.095,1.447,1.447,0,0,1-.633-.643,1.474,1.474,0,0,1,0-1.694l.035-.029c.2-.189.41-.379.618-.567l.533-.482c.2-.19.41-.379.617-.563a.6.6,0,0,1,.682-.1A1.454,1.454,0,0,1,274.853,804.174Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2142-2-8" data-name="Path 2142-2-8" d="M283.289,796.284h0a1.448,1.448,0,0,1,.043-1.694l.02-.016,1.767-1.562a.642.642,0,0,1,.693-.1,1.468,1.468,0,0,1,.643.663,1.448,1.448,0,0,1-.04,1.688l-.021.016c-.194.178-.394.349-.59.521l-1.189,1.043a.608.608,0,0,1-.685.1A1.478,1.478,0,0,1,283.289,796.284Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2143-2-8" data-name="Path 2143-2-8" d="M280.094,788.445v3.335a1.116,1.116,0,0,1-.281.824.562.562,0,0,1-.621.061,1.831,1.831,0,0,1-.9-1.6v-3.41a1.079,1.079,0,0,1,.282-.831.557.557,0,0,1,.643-.045,1.875,1.875,0,0,1,.884,1.639Z" fill="#75fffa"/>
        <path id="Path_2144-2-8" data-name="Path 2144-2-8" d="M286.784,811.822a1.557,1.557,0,0,1,.063,1.734l-.024.024a.555.555,0,0,1-.632.082,1.57,1.57,0,0,1-.686-.7q-.893-1.581-1.781-3.183a1.534,1.534,0,0,1-.037-1.727l.013-.011a.555.555,0,0,1,.624-.087,1.6,1.6,0,0,1,.693.7c.2.362.409.728.612,1.1Z" fill="#75fffa" opacity="0.5" style="isolation: isolate"/>
        <path id="Path_2145-2-8" data-name="Path 2145-2-8" d="M289.115,804.574v.008a.979.979,0,0,1-.256.731.613.613,0,0,1-.693.071c-.409-.175-.819-.355-1.229-.535s-.865-.38-1.3-.574a1.814,1.814,0,0,1-.933-1.574v-.028a.951.951,0,0,1,.252-.733.6.6,0,0,1,.694-.074l2.509,1.1a1.819,1.819,0,0,1,.955,1.575Z" fill="#75fffa"/>
      </g>
    </g>
  </g>
</svg>

                  </span>
                  <span class="points">
                    <span class="p1"></span><span class="p2"></span> <span class="p3"></span><span class="p4"></span><span class="p5"></span><span class="p6"></span>
                  </span>
                  <span class="legs2"></span>
                  <span class="rd-clyndr">
                    <img src="/theme/img/rd-clndr.png">
                     <img class="anim" src="/theme/img/coinanim.gif">
                  </span>
                  <div class="rm1">
                      <h3>CONNECT YOUR ACCOUNT</h3>
                      <p>Map your trading account to AlphaQ to start the process.</p>
                  </div>
                  <div class="rm2">
                      <h3>Subscribe to strategise</h3>
                      <p>Subscribe to optimisation algorithms and deploy your trade.</p>
                  </div>
                  <div class="rm3">
                      <h3>Track your growth</h3>
                      <p>Analyze your growth using our easy to tracking and monitoring system.</p>
                  </div>
                  <img class="hidden base-img1" src="/theme/img/roadmap.png">
                  <img class="hidden base-img2" src="/theme/img/roadmap-mob.png">
              </div>
          </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.sec-03-hex{
  width: 100%;
    height: 100%;
    position: absolute;
    display: inline-block;
    z-index: 0;
    left: 0px;
    top: 0px;
}
.model1{
   width: 20%;
    height: 100%;
    position: absolute;
    top: -8%;
}
.model1 , .model2 ,.model3{
  overflow: hidden;
}

.model1::before{
 content: '';
    background: url(/theme/img/sec2-hex.svg);
    background-size: 164%;
    background-repeat: no-repeat;
    background-position: 126% 0%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    opacity: 1;
}

.model1 .blue-light:nth-child(1){
 top:8%;
  left: 4%;
animation-duration: 2.1s; -webkit-animation-duration: 2.1s; 
}
.model1 .blue-light:nth-child(2){
     top: 25%;
    left: 32%;
    animation-duration: 2.4s; -webkit-animation-duration: 2.4s; 
}
.model1 .blue-light:nth-child(3){
 top: 39%;
    left:  46%;
     animation-duration: 2s; -webkit-animation-duration: 2s;
}
.model1 .blue-light[data-v-6793b5e0]:nth-child(4) {
    top: 51%;
    left: 18%;
    animation-duration: 2.6s;
    -webkit-animation-duration: 2.6s;
}

.model2{
   width: 20%;
    height: 100%;
    position: absolute;
    top: -8%;
    right: 4%;
}
.model2::before{
    content: '';
    background: url("/theme/img/sec2-hex2.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 0% 0%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    opacity: 1;
}

.model2 .blue-light:nth-child(1){
    top: 21%;
    left: 5%;
    animation-duration: 2.1s; -webkit-animation-duration: 2.1s; 
}
.model2 .blue-light:nth-child(2){
    top:7%;
    left: 66%;
    animation-duration: 2.4s; -webkit-animation-duration: 2.4s; 
}
.model3{
    width: 20%;
    height: 100%;
    position: absolute;
    top: 18%;
    right: 0%;
}
.model3::before{
    content: '';
    background: url(/theme/img/sec2-hex3.svg);
    background-size: 150%;
    background-repeat: no-repeat;
    background-position:-50% 82%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    opacity:1;
}
.model3 .blue-light{
  bottom: 0%;
  top: unset;
  left:unset;
}
.model3 .blue-light:nth-child(1) {
    bottom: 14%;
    right: -3%;
    animation-duration: 2.1s;
    -webkit-animation-duration: 2.1s;
}
.model3 .blue-light:nth-child(2){
 bottom: 16%;
    right: 34%;
     animation-duration: 2.3s; -webkit-animation-duration: 2.3s; 
}

.model3 .blue-light:nth-child(3){
     bottom: 32%;
    right: 9%;
     animation-duration: 2.5s; -webkit-animation-duration: 2.5s; 
}
.model3 .blue-light:nth-child(4){
    bottom: 45%;
    right: -3%;
     animation-duration: 2.5s; -webkit-animation-duration: 2.5s; 
}
.roadmap-container .points {
    width: 100%;
    position: absolute;
     z-index: 1;
    height: 100%;
}
.roadmap-container .points span{
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #fff;
    display: inline-block;
    box-shadow: 0px 0px 14px 0px rgb(55 162 204);
    position: absolute;
    transform: translate(-100% , 0%);
    user-select: none;
    pointer-events: none;
}
.roadmap-container .points span.p1{
    bottom: 28%;
    left: 8%;
    animation: mover1 10s ease-in-out infinite;
}
.roadmap-container .points span.p2{
    bottom: 28%;
    left: 8%; 
    animation: mover1 10s ease-in-out infinite;
    animation-delay: 5s;
}
.roadmap-container .points span.p3{
    bottom: 34%;
    left: 28%;
    animation: mover2 5s ease-in-out infinite;
}
.roadmap-container .points span.p4{
    bottom: 34%;
    left: 28%;
    animation: mover2 5s ease-in-out infinite;
    animation-delay: 2.5s;
}
.roadmap-container .points span.p5{
  bottom: 61%;
  left: 33%;
  animation: mover3 3s ease-in-out infinite;
}
.roadmap-container .points span.p6{
  bottom: 44%;
  left: 49.5%;
  animation: mover4 3s ease-in-out infinite;
}
.roadmap-container .points .lt1{
  width: 30px;
  height: 30px;
  display: none;
}
.roadmap-container .c-lights{
    width: 10%;
    position: absolute;
    height: 14%;
    z-index: 3;
    top: 42.6%;
    left: 37.2%;
}
.roadmap-container .c-lights svg{
  width: 100%;
}
.roadmap-container .c-lights svg #bl1{
   animation: fade infinite;
  -webkit-animation: fade infinite;
  animation-duration: 3s;
  -webkit-animation-duration: 3s;
}
.roadmap-container .c-lights svg #bl2{
   animation: fade infinite;
  -webkit-animation: fade infinite;
  animation-duration: 2.4s;
  -webkit-animation-duration: 2.4s;
}
.roadmap-container .c-lights svg #bl3{
   animation: fade infinite;
  -webkit-animation: fade infinite;
  animation-duration: 2.8s;
  -webkit-animation-duration: 2.8s;
}
.roadmap-container .c-lights svg #bl4{
   animation: fade infinite;
  -webkit-animation: fade infinite;
  animation-duration:  3.2s;
  -webkit-animation-duration: 3.2s;
}
.rd-clyndr{
    width: 8%;
    position: absolute;
    bottom: 30%;
    left: 56%;
    z-index: 2;
}
.rd-clyndr::before{
  position: absolute;
  content: '';
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  z-index: 3;
  background: url("/theme/img/rd-clndr.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.rd-clyndr::after{
  position: absolute;
  content: '';
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: url("/theme/img/rd-clndr-base.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.rd-clyndr img{
  width: 100%;
  opacity: 0;
  visibility: hidden;
}
.rd-clyndr .anim{
  position: absolute;
  opacity: 1;
  visibility: visible;
  left: 0%;
  z-index: 2;
}
@keyframes mover1 {
    0% {
       bottom: 28%;
       left: 8%;
       box-shadow: 0px 0px 14px 4px rgb(55 162 204);
       opacity: 1;
    }
    10%{
      box-shadow: 0px 0px 14px 8px rgb(55 162 204);
    }
     15%{
      box-shadow: 0px 0px 14px 4px rgb(55 162 204);
    }
    20% {
      bottom: 34%;
      left: 14%;
      box-shadow: 0px 0px 14px 8px rgb(55 162 204);
      opacity: 0;
    }
    30%{
        bottom: 34%;
        left: 15%;
        opacity: 1;
        box-shadow: 0px 0px 14px 4px rgb(55 162 204);
    }
    40%{
      box-shadow: 0px 0px 14px 8px rgb(55 162 204);
    }
    50%{
      bottom: 23%;
      left: 15%;
      opacity: 0;
    }
    55%{
      bottom: 22%;
      left: 16%;
      opacity: 0;
      box-shadow: 0px 0px 14px 4px rgb(55 162 204);
    }
    60%{
       opacity: 1;
    }
    70%{
      box-shadow: 0px 0px 14px 8px rgb(55 162 204);
    }
    80%{
        bottom: 26%;
        left: 20%;
        opacity: 0;
    }
    100%{
       opacity: 0;
    }
    
}
@keyframes mover2{
   0% {
       bottom: 34%;
       left: 28%;
       box-shadow: 0px 0px 14px 4px rgb(55 162 204);
       opacity: 1;
    }
    25%{
       box-shadow: 0px 0px 14px 8px rgb(55 162 204);
        opacity: 1;
    }
    50%{
       box-shadow: 0px 0px 14px 4px rgb(55 162 204);
       
    }
    75%{
       box-shadow: 0px 0px 14px 8px rgb(55 162 204);
        opacity: 1;
    }
    100%{
      bottom: 43%;
      left: 37%;
      opacity: 0;
    }
} 
@keyframes mover3{
   0% {
     bottom: 57%;
      left: 37%;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
    opacity: 1;
   }
   20%{

     opacity: 1;
   }
   50%{
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
   }
   80% {
       box-shadow: 0px 0px 14px 4px rgb(55 162 204);
       opacity: 1;
   }
   100%{
      bottom: 61%;
    left: 33%;
      
      opacity: 0;
   }
}
@keyframes mover4{
   0% {
  
     bottom: 44%;
    left: 49.5%;
    box-shadow: 0px 0px 14px 4px rgb(55 162 204);
    opacity: 1;
   }
   20%{
  
     opacity: 1;
   }
   50%{
     box-shadow: 0px 0px 14px 8px rgb(55 162 204);
   }
   80% {
       box-shadow: 0px 0px 14px 4px rgb(55 162 204);
       opacity: 1;
   }
   100%{
       bottom: 39.5%;
     left: 54.2%;
    
      opacity: 0;
   }
}
@media (max-width: 800px) {
      .sec-03-hex .model2{
        width: 40%;
        top:-20%;
    }

  .model2 .blue-light:nth-child(1) {
    top: 12.5%;
    left: 6%;
    animation-duration: 2.1s;
    -webkit-animation-duration: 2.1s;
    width: 7vw;
    height: 5vh;
}
  .model2 .blue-light:nth-child(2) {
    top: 3%;
    left: 64%;
}
.roadmap-container .points{
      /* z-index: 2; */
}
.roadmap-container .points span.p1{
    animation: none;
    top: 22%;
    right: 33%;
    left: unset;
    bottom: unset;
    animation: mover1 2s ease-in-out infinite;
}
.roadmap-container .points span.p2{
    animation: none;
    left: 38%;
    bottom: unset;
    top: 33%;
    animation: move2 5s ease-in-out infinite;
}
.roadmap-container .points span.p3{
  animation: none;
  bottom: unset;
    top: 48%;
    left: 40%;
    animation: move3 4s ease-in-out infinite;
}
.roadmap-container .points span.p4{
  animation: none;
  bottom: unset;
  left: unset;
  top: 56%; 
  right: 18%;
  animation: move4 6s ease-in-out infinite;
}
.roadmap-container .points span.p5{
  animation: none;
  display: none;
}
.roadmap-container .points span.p6{
  animation: none;
  display: none;
}
@keyframes mover1 {
  0% {
     top: 22%;
     right: 33%;
     box-shadow: 0px 0px 14px 3px rgb(55 162 204);
     opacity: 1;
   }
   20%{
     opacity: 1;
   }
   50%{
     box-shadow: 0px 0px 14px 6px rgb(55 162 204);
   }
   80% {
       box-shadow: 0px 0px 14px 3px rgb(55 162 204);
       opacity: 1;
   }
   100%{
    top: 26%;
      right: 41%;
     opacity: 0;
   }
}

@keyframes move2 {
  0%{
    left: 38%;
    top: 33%;
     opacity: 1;
     box-shadow: 0px 0px 14px 3px rgb(55 162 204);
  }
  30%{
     box-shadow: 0px 0px 14px 6px rgb(55 162 204);
  }
  70%{
    box-shadow: 0px 0px 14px 3px rgb(55 162 204);
    opacity: 1;
   
  }
  80%{
    left: 11%;
    top: 45%;
    opacity: 0;
  }
  85%{
    
    left: 10%;
    top: 46%;
  }
  90%{
    left: 11%;
    top: 47%;
    box-shadow: 0px 0px 14px 3px rgb(55 162 204);
    opacity: 1;
  }
  100%{
    left: 14%;
    top: 48%;
     opacity: 0;
  }
  
}
@keyframes move3 {
  0%{
    top: 48%;
    left: 40%;
    opacity: 1;
     box-shadow: 0px 0px 14px 3px rgb(55 162 204);
  }
  40%{
    top: 44%;
    left: 49%;
    opacity: 0;
  }
  60%{
    top: 43.8%;
    left: 52%;
    opacity: 1;
     box-shadow: 0px 0px 14px 6px rgb(55 162 204);
  }
  100%{
    top: 48%;
    left: 62%;
    opacity: 0;
    box-shadow: 0px 0px 14px 3px rgb(55 162 204);
  }
}
@keyframes move4 {
0%{
   top: 56%; 
  right: 18%;
  opacity: 1;
  box-shadow: 0px 0px 14px 3px rgb(55 162 204);
}
15%{
  opacity: 1;
  box-shadow: 0px 0px 14px 6px rgb(55 162 204);
}
30%{
    top: 62%;
    right: 4%;
    opacity: 0;
}
45%{
   top: 63.5%;
    right: 4%;
    opacity: 1;
  box-shadow: 0px 0px 14px 3px rgb(55 162 204);
}
80%{
  box-shadow: 0px 0px 14px 6px rgb(55 162 204);
}
100%{
    top: 73%;
    right: 27%;
    
     opacity: 0;
}
}
.roadmap-container .c-lights{
    width: 20%;
    height: 20%;
    top: 49%;
    left: 14%;
}
.rd-clyndr {
    width: 15%;
    bottom: 16%;
    left: 46%;
}
}
</style>

<script>
import ScrollMagic from "scrollmagic";
import helpers from '@/plugins/helpers' 

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    titleSub:{
      type: String,
      default: ""
    }
  },
   mounted() {
     this.onscrollHandler()
   },
  methods: {
    onscrollHandler() {
      var controller = new ScrollMagic.Controller();
      var scene = new ScrollMagic.Scene({
        triggerElement: ".sec-03",
        offset: window.innerHeight * 0.46,
        duration: helpers.isMobile()?"10%":"50%",
      }).setPin(".sec-03");
       scene.on("enter progress", function (e) {
        if (e.scrollDirection == "FORWARD") {
          if (e.progress >0){
            document.querySelector('.sec-03  .has-u-line').classList.add('sec-active')
          }
        }else if (e.scrollDirection == "REVERSE") {
           if (e.progress ==0){
            document.querySelector('.sec-03 .has-u-line').classList.remove('sec-active')
          }
        }})
      controller.addScene([scene]);
    }
  }
};
</script>